<template>
  <div id="chart">
    <apexchart
      type="area"
      height="180"
      ref="chart"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "AreaChart",

  components: {
    apexchart: VueApexCharts,
  },

  props: {
    yData: {
      type: Array,
      default: () => [],
    },
    yAxisName: {
      type: String,
      default: "",
    },
    yLabel: {
      type: String,
      default: "Volume"
    }
  },

  data: () => ({
    series: [
      {
        name: "Volume",
        data: [
          {
            x: "HelloWorld_DGR",
            y: 2020,
          },
        ],
      },
    ],
    chartOptions: {
      chart: {
        type: "area",
        animations: {
          enabled: false,
        },
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      fill: {
        opacity: 0.8,
      },
      theme: {
        palette: "palette1",
      },
      xaxis: {
        type: "time",
        tickAmount: 6,
        labels: {
          rotate: 0,
        },
      },
      yaxis: {
        title: {
          text: "",
        },
      },
    },
    //
  }),

  watch: {
    yData: function(newVal) {
      this.series[0].data = newVal;
      this.setMinMaxScale(this.yAxisName);
      this.$refs.chart.refresh();
    },
  },

  methods: {
    setNameYAxis() {
      this.series[0].name = this.yLabel;
    },
    setData() {
      this.series[0].data = this.yData;
    },
    setMinMaxScale(tankType) {
      switch (tankType) {
        case "mainTank":
          this.chartOptions.yaxis.min = 100;
          this.chartOptions.yaxis.max = 300;
          this.chartOptions.yaxis.tickAmount = 5;
          break;

        case "subTank":
          this.chartOptions.yaxis.min = 0;
          this.chartOptions.yaxis.max = 150;
          this.chartOptions.yaxis.tickAmount = 5;
          break;
        
        default:
          break;
      }
    },
  },
}
</script>